import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-vb-payments-estimated-annual-total',
  templateUrl: './vb-payments-estimated-annual-total.component.html',
  styleUrls: ['./vb-payments-estimated-annual-total.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentsEstimatedAnnualTotalComponent {
  @Input() estimatedAnnualTotal = 0;
}
